import React, { useState, useEffect } from 'react'
import './ProductoDetalleExpositorPage.scss';
import Path from '../components/Path'
import { ProductImageSlider } from '../components/ProductImageSlider';
import { ProductoDetalleHeader } from '../components/ProductoDetalleHeader'
import ProductoDetalleBtnCompra from '../components/ProductoDetalleBtnCompra'
import ProductoDetalleCantidad from '../components/ProductoDetalleCantidad'
import { ProductoDetalleDescripcion } from '../components/ProductoDetalleDescripcion'
import Separator from '../components/Separator';
import { connect as connectRedux } from 'react-redux'
import { useParams } from 'react-router-dom';
import * as _ from 'lodash'
import { setFormatSelected } from '../actions/index'
import { privilegeUser } from '../hooks/user';
import { scrollBodyTop } from '../hooks/scrollPosition';
import ContentExpositor from '../components/ContentExpositor';
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import ProductoComplementario from '../components/ProductoComplementario';
import {OptionsProductDesactivate} from '../components/OptionsProductDesactivate';
import { getProducts, getProductsExpositors, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from '../hooks/gets';
import { productInOutlet } from '../hooks/productInOutlet'
import { BRANDCHOSEN } from '../hooks/config';

const findProductById = (allProducts, id) => {
  const products = allProducts[BRANDCHOSEN] ? allProducts[BRANDCHOSEN] : allProducts
    for (let i = 0; i < products.length; i++) {
        const el = products[i];
        if (el.ID === id) {
            return el
        }
    }
}

const findProductsExpositorById = (product, allProduct) => {
    const productExpositors = JSON.parse(product.ProductosExpositor);
    let productsInExpositor = []
    for (let i = 0; i < productExpositors.length; i++) {
        const product = productExpositors[i];
        const productData = _.filter(allProduct[BRANDCHOSEN], productList => {
            return productList.RefSuelto.trim() === product.RefSuelto.trim()
        })
        if(productData[0]){
          const productQuantity = { product: productData[0], quantity: product.Quantity }
          productsInExpositor.push(productQuantity)
        }
    }
    return productsInExpositor;
}

const ProductoDetalleExpositorPage = (props) => {
    const { id } = useParams();
    const [product, setProduct] = useState(undefined)
    const [productsExpositor, setProductsExpositor] = useState([])
    const [showProductComplement, setShowProductComplement] = useState(false)
    const [productInExpositor, setProductInExpositor] = useState(false)
    const [privilege, setPrivilege] = useState(undefined)

    const [outlet, setOutlet] = useState([])
    const [promoA, setPromoA] = useState([])
    const [promoB, setPromoB] = useState([])
    const [promoC, setPromoC] = useState([])

    useEffect(() => {
        scrollBodyTop()
        getPrivilege()
        loadProducts()
        props.setFormatSelected('expositor')
    }, [])

    const loadProducts = async () => {
        setOutlet(await getProductsOutlet())
        setPromoA(await getProductsPromoA())
        setPromoB(await getProductsPromoB())
        setPromoC(await getProductsPromoC())
    }

    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    useEffect(() => {
        loadData().then(()=>{
        //Necesario para que se ejecute despues de crearse el componente
       })
    }, [props.allProducts, id, outlet, promoA, promoB, promoC])


    const loadData = () => {
      return new Promise(async(resolve)=>{
        getProducts().then(async res => {
            const productData = findProductById(props.allProducts, id)
            if (productData !== undefined) {
                const productsExpositor = findProductsExpositorById(productData, res)
                const product = await productInOutlet(productData)
                if (product !== undefined) {
                    productData.Descuento = product.Descuento
                    productData.PrecioTarifa = product.PrecioTarifa
                }
                setProductsExpositor(productsExpositor)
                setProduct(productData)
            }
        })
        resolve()
      })
    }

    const handleSelectProductInExpositor = (product) => {
        setShowProductComplement(true)
        setProductInExpositor(product.product)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(true)
    }

    const handleCloseProductComplement = () => {
        setShowProductComplement(false)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
    }

    return (
        <div className="productos-detalle-expositor-page-container">
            {
                showProductComplement &&
                <ProductoComplementario product={productInExpositor} clickClose={handleCloseProductComplement} ></ProductoComplementario>
            }
            {product !== undefined &&
                <React.Fragment>
                    <div className="path">
                        <Path path="Inicio" />
                    </div>
                    <div className="product">
                        <div className="img">
                            <ProductImageSlider product={product}></ProductImageSlider>
                        </div>
                        <div className="title">
                            <ProductoDetalleHeader product={product} nombre={product.Nombre} descuento={product.Descuento} productsTable={props.productsTable}></ProductoDetalleHeader>
                            <div className="separator">
                                <Separator />
                            </div>
                        </div>
                        <div className="options mobile">
                            {!_.isEmpty(props.userActive) ?
                                <React.Fragment>
                                    <div><ProductoDetalleCantidad producto={product} /></div>
                                    <div className="boton-compra"><ProductoDetalleBtnCompra product={product}></ProductoDetalleBtnCompra></div>
                                    <div className="precio">
                                        {privilege &&
                                            <p>Precio de venta recomendado <strong>{product.PrecioTarifa}€</strong></p>
                                        }
                                    </div>
                                </React.Fragment>
                                :
                                <OptionsProductDesactivate></OptionsProductDesactivate>
                            }

                        </div>
                        <div className="details">
                            <div className="description mobile">
                                <div className="separator"><Separator /></div>
                                <ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion>
                                <div className="separator"><Separator /></div>
                            </div>

                            <div className="description-count desktop">
                                <div className="description">
                                    <ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion>
                                    <div className="separator"><Separator /></div>
                                </div>
                            </div>

                            <ContentExpositor productsExpositor={productsExpositor} product={product} clickProductSelected={handleSelectProductInExpositor}></ContentExpositor>

                            <div className="separator"><Separator /></div>
                            <div className="description-count desktop">
                                <div className="count">
                                    {!_.isEmpty(props.userActive) ?
                                        <React.Fragment>
                                            <div className="cantidad"><ProductoDetalleCantidad producto={product} /></div>
                                            <div className="boton-compra"><ProductoDetalleBtnCompra product={product}></ProductoDetalleBtnCompra></div>
                                            <div className="precio">
                                                {privilege &&
                                                    <p>Precio de venta recomendado <strong>{product.PrecioTarifa}€</strong></p>
                                                }
                                            </div>

                                        </React.Fragment>
                                        :
                                        <OptionsProductDesactivate></OptionsProductDesactivate>
                                    }
                                </div>
                            </div>


                        </div>

                    </div>
                </React.Fragment>
            }
        </div>
    )
}
const mapDispatchToProps = {
    setFormatSelected
}

const mapStateToProps = state => state

export default connectRedux(mapStateToProps, mapDispatchToProps)(ProductoDetalleExpositorPage)